export const ABOARD_POINT = "aboard_point"
export const USEFUL_POINT = "useful_point"
export const HOT_POINT = "hot_point"
export const ROUTE = "route"
